import { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import useLoading from './useLoading';
import { URL } from '../constant';
import { errorMessage } from '../redux/errorState';


export default function useRequest(api, isLoad) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { setLoading, clearLoading } = useLoading();

  
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const onRequest = useCallback(
    async(...params) => {
      try {
        if (isLoad) setLoading({ isShowSpinner: true, spinnerType: '1' });
        
        const response = await api(...params);
        if (!response) return;
        setData(response);
      } catch (e) {
        setError(e);
        if (e && e.code) {
          if (e.code === 'S000001') {
            alert(`error code: ${e.code}`);
            history.push(URL.ERROR.PAGE);
          } else {
            dispatch(errorMessage(e.code, e.data.message));
          }
        }
        // throw e;
      } finally {
        if (isLoad) clearLoading();
      }
      
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onReset = () => {
    setData(null);
    setError(null);
  }

  return [onRequest, data, error, onReset];
}